import { Pipe, PipeTransform } from '@angular/core';
import { isNil } from 'lodash';

import { DATETIME_LOCAL_CONTROL_STR_FORMAT } from '../../../common/objects/form-helper';

@Pipe({
  name: 'datetimeLocalPipe',
})
export class DatetimeLocalPipePipe implements PipeTransform {
  transform(value: moment.Moment, timezone: string | undefined): string {
    if (isNil(timezone)) {
      return value.format(DATETIME_LOCAL_CONTROL_STR_FORMAT);
    }
    return value.tz(timezone).format(DATETIME_LOCAL_CONTROL_STR_FORMAT);
  }
}
